import { isViewSettingAsPanelExpEnabledWithNoExposure } from '../../../feature-flags.tsx';
import {
	INSIGHTS_PANEL,
	ISSUE_PARENT_PANEL,
	VERSION_PANEL,
	VIEW_SETTINGS_PANEL,
} from '../../../model/panels/constants.tsx';
import type { State } from '../../types.tsx';

export const getPanels = (state: State) => state.ui.panels;

export const getEpicPanel = (state: State) => state.ui.panels[ISSUE_PARENT_PANEL] || false;
export const getVersionPanel = (state: State) => state.ui.panels[VERSION_PANEL] || false;
export const getInsightsPanel = (state: State) => state.ui.panels[INSIGHTS_PANEL] || false;
export const getViewSettingsPanel = (state: State) =>
	(isViewSettingAsPanelExpEnabledWithNoExposure() && state.ui.panels[VIEW_SETTINGS_PANEL]) || false;
